import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { getUserRole, checkPermission } from "utils/auth";
import routes from "../../routes";

const Sidebar = ({ open, onClose }) => {
  const userRole = getUserRole();

  // Filtrer les routes selon la permission de l'utilisateur
  const authorizedRoutes = routes.filter(
    (route) =>
      (!route.requiredRole || checkPermission(route.requiredRole, userRole)) &&
      route.isShow !== false
  );

  return (
    <div
      className={`sm:none duration-175 linear fixed inset-y-0 left-0 z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-transform dark:!bg-navy-800 dark:text-white ${
        open ? "translate-x-0" : "-translate-x-full"
      } w-64`}
    >
      {/* Bouton de fermeture (mobile) */}
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX size={24} />
      </span>

      {/* Logo et rôle */}
      <div className="mx-auto mt-10 flex flex-col items-center space-y-1">
        <div className="font-poppins text-[22px] font-bold uppercase text-[#57A863] dark:text-white">
          MADATLAS
        </div>
        <p className="text-[#57A863] dark:text-white">{userRole}</p>
      </div>

      <div className="my-4 h-px bg-gray-300 dark:bg-white/30" />

      {/* Menu déroulant avec scroll si nécessaire */}
      <div className="flex-1 overflow-y-auto px-2">
        <ul className="pt-1">
          <Links routes={authorizedRoutes} />
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
